// Mirrors app_be/utils/passwordReset.js's MIN_PASSWORD_LENGTH/isValidNewPassword
// — can't literally share the backend's JS constant across a network
// boundary, but this is the one place on the frontend to update if that
// policy ever changes, instead of a separate inline `.length < 6` copy in
// every page with a password field (ProfilePage, ForgotPasswordPage).
export const MIN_PASSWORD_LENGTH = 6;

export function isValidNewPassword(password: string): boolean {
  return password.length >= MIN_PASSWORD_LENGTH;
}
